import React from 'react';
import { SectionCta } from './SectionCta';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section className="bg-white px-5 py-16 sm:py-24" aria-labelledby="pain-title" data-id="element-216" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-5xl" data-id="element-217" data-mp="26xecp2oks4zn">
        <h2 id="pain-title" className="text-center font-display text-4xl font-bold uppercase leading-tight text-navy-900 sm:text-5xl" data-id="element-218" data-mp="26wlg2ujbyvv8">
          Do any of these situations sound familiar?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-lg text-muted" data-id="element-219" data-mp="21zurfitgmry7">
          If you answer <strong className="text-alert-deep" data-id="element-220" data-mp="1nztps15dfgho">YES</strong> to even one of these, I created Implant Risk
          Radar™ for you.
        </p>

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-221" data-mp="1szg64jghxcup">
          {painPoints.map(({
          icon: Icon,
          text
        }) => <li key={text} className="flex gap-4 rounded-2xl border border-navy-900/10 bg-canvas p-5" data-id="element-222" data-mp="3iee4lx70ght5">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-alert-light" data-id="element-223" data-mp="3nbwf3s0of539">
                <Icon className="h-6 w-6 text-alert-deep" aria-hidden="true" data-id="element-224" data-mp="1yybzrj2styog" />
              </span>
              <p className="text-[17px] leading-snug text-ink" data-id="element-225" data-mp="1tzraufszz1fb">{text}</p>
            </li>)}
        </ul>

        <SectionCta label="Yes — I need a structured system" data-id="element-226" data-mp="23rdgzxqhaab7" />
      </div>
    </section>;
}